import * as ng from 'angular';

import {GuestType, GuestTypeService} from './guest-type.service';

export class GuestTypeEditController implements ng.IController {
   static $inject = ['$uibModalInstance', 'GuestTypeService', 'guestType', 'loader'];

   constructor(
      private $uibModalInstance,
      private guestTypeService:GuestTypeService,
      private guestType:GuestType,
      private loader
   ) { }

   cancel() {
      this.$uibModalInstance.dismiss('cancel');
   }

   save() {
      let promise:ng.IPromise<GuestType>;

      this.loader.showSpinner();
      if (this.guestType.id == 0) {
         promise = this.guestTypeService.create(this.guestType);
      } else {
         promise = this.guestTypeService.update(this.guestType);
      }

      promise.then(() => {
         this.$uibModalInstance.close();
      }).finally(() => {
         this.loader.hide();
      });
   }
}

ng.module('e360')
   .controller('GuestTypeEditController', GuestTypeEditController);
